import Wave from "./Wave";
const services = [
    {
        'title':'Expert Teachers',
        'illustration': '/images/expertTeachers.svg',
    },
    {
        'title':'Online Stress free management tools for students and teachers',
        'illustration': '/images/tools.svg',
    },
    {
        'title':'Refer Your Friends to earn more benefits',
        'illustration': '/images/sharingiscaring.svg',
    },
    {
        'title':'Online Notes Management',
        'illustration': '/images/notes.svg',
    },
    {
        'title':'Learn and teach Online on our Platform',
        'illustration': '/images/onlinetool.svg',
    },
    {
        'title':'Smart Tools for Teaching (Tutor Kits)',
        'illustration': '/images/smarttools.svg',
    },
    {
        'title':'Track your performance and Leaderboards',
        'illustration': '/images/progress.svg',
    },
    {
        'title':'Pay Tution Fees Online',
        'illustration': '/images/fees.svg',
    },
    
]
function Services() {
    return (
        <div className="services" id="services">
            <h1 className="servicesTitle">Services</h1>
            <div className="servicesGrid">
                {services.map((service,index) => {
                    return (
                        <div className="service" key={index}>
                            <img className="serviceImg" src={service.illustration} alt="service"/>
                            <p className="serviceTitle">{service.title}</p>
                        </div>
                    );
                })}
            </div>
            <Wave up={true}></Wave>
        </div>
    )
}
export default Services;